import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const setMetaDataForVideo = (numberOfBlocks, fileName, fileSize, className) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.SET_METADATA_FOR_VIDEO(
      numberOfBlocks,
      fileName,
      fileSize,
      className
    )
  );
};

export default setMetaDataForVideo;
